type ProjectFileLike = {
  path: string;
  parentPath?: string | null;
  order?: number | null;
};

const inferParentPath = (path: string) =>
  path.includes("/") ? path.slice(0, path.lastIndexOf("/")) : "";

const compareMaybeNumber = (left?: number | null, right?: number | null) => {
  const hasLeft = typeof left === "number";
  const hasRight = typeof right === "number";
  if (hasLeft && hasRight && left !== right) {
    return left - right;
  }
  if (hasLeft && !hasRight) return -1;
  if (!hasLeft && hasRight) return 1;
  return 0;
};

export const compareProjectFilesByOrder = (left: ProjectFileLike, right: ProjectFileLike) => {
  const leftParent = left.parentPath ?? inferParentPath(left.path);
  const rightParent = right.parentPath ?? inferParentPath(right.path);

  if (leftParent === rightParent) {
    const orderDiff = compareMaybeNumber(left.order, right.order);
    if (orderDiff !== 0) return orderDiff;
  }

  return left.path.localeCompare(right.path, undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

export const sortProjectFilesByOrder = <T extends ProjectFileLike>(files: T[]) =>
  [...files].sort(compareProjectFilesByOrder);
